import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllPriceSchemes } from 'src/api/getAllPriceSchemes/getAllPriceSchemes';
import { QueryKeys } from '../QueryKeys';
import { IPriceScheme } from 'src/types/price.types';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';

const staleTime = 5 * 60 * 1000; // 5 minutes

export const usePriceScheme = (priceSchemeId?: string) => {
  const selectPriceScheme = useCallback(
    (priceSchemes: IPriceScheme[]) => priceSchemes.find(({ id }) => id === priceSchemeId),
    [priceSchemeId],
  );

  return useQuery({
    queryKey: [QueryKeys.priceSchemes, getBrandId()],
    queryFn: getAllPriceSchemes,
    staleTime,
    select: selectPriceScheme,
    enabled: !!priceSchemeId,
  });
};
